(function () {
  const STORAGE_KEY = 'blo_search_history_v1';
  const MAX_ITEMS = 6;

  function getHistory() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list.slice(0, MAX_ITEMS) : [];
    } catch (e) {
      return [];
    }
  }

  function saveQuery(query) {
    if (!query) return;
    const clean = query.trim();
    if (!clean || clean.length < 2) return;
    try {
      let history = getHistory();
      history = history.filter((item) => item.toLowerCase() !== clean.toLowerCase());
      history.unshift(clean);
      history = history.slice(0, MAX_ITEMS);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(history));
    } catch (e) {}
  }

  function removeQuery(query) {
    try {
      let history = getHistory();
      history = history.filter((item) => item.toLowerCase() !== query.toLowerCase());
      localStorage.setItem(STORAGE_KEY, JSON.stringify(history));
    } catch (e) {}
  }

  function clearHistory() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  // Auto-save if currently on search page
  try {
    const url = new URL(window.location.href);
    if (url.pathname.includes('/search')) {
      const q = url.searchParams.get('q');
      if (q) saveQuery(q);
    }
  } catch (e) {}

  function escapeHtml(str) {
    return (str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderHistoryHtml() {
    let history = getHistory();
    if (!history || history.length === 0) return '';
    history = history.slice(0, MAX_ITEMS);
    return `
      <div class="blo-search-history-header">
        <span class="blo-search-history-title">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
          </svg>
          Recent Searches
        </span>
        <button type="button" class="blo-search-history-clear" data-blo-action="clear">Clear all</button>
      </div>
      <ul class="blo-search-history-list">
        ${history.map((term) => `
          <li class="blo-search-history-item" data-blo-query="${escapeHtml(term)}">
            <div class="blo-search-history-item-left">
              <svg class="blo-search-history-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg>
              <span class="blo-search-history-item-text">${escapeHtml(term)}</span>
            </div>
            <button type="button" class="blo-search-history-item-remove" data-blo-action="remove" data-blo-remove="${escapeHtml(term)}" title="Remove">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </li>
        `).join('')}
      </ul>
    `;
  }

  function getOrCreateDropdown(input) {
    const parent = input.closest('.field') || input.parentElement;
    if (!parent) return null;
    let dropdown = parent.querySelector('.blo-search-history');
    if (!dropdown) {
      dropdown = document.createElement('div');
      dropdown.className = 'blo-search-history';
      dropdown.setAttribute('role', 'region');
      dropdown.setAttribute('aria-label', 'Recent searches');
      dropdown.style.display = 'none';
      parent.appendChild(dropdown);
    }
    return dropdown;
  }

  function showForInput(input) {
    if (!input) return;
    const history = getHistory();
    if (!history || history.length === 0) {
      hideAll();
      return;
    }
    if (input.value.trim().length > 0) {
      hideAll();
      return;
    }
    const dropdown = getOrCreateDropdown(input);
    if (!dropdown) return;
    dropdown.innerHTML = renderHistoryHtml();
    dropdown.style.display = 'block';
  }

  function hideAll() {
    document.querySelectorAll('.blo-search-history').forEach((d) => {
      d.style.display = 'none';
    });
  }

  // Event Delegation for Focus and Click on any search input (desktop, mobile popup, drawer)
  document.addEventListener('focusin', function (e) {
    if (e.target.matches('input[type="search"], input[name="q"]')) {
      showForInput(e.target);
    }
  });

  document.addEventListener('click', function (e) {
    // If clicking a search input
    if (e.target.matches('input[type="search"], input[name="q"]')) {
      showForInput(e.target);
      return;
    }

    // If clicking "Clear all" inside dropdown
    const clearBtn = e.target.closest('[data-blo-action="clear"]');
    if (clearBtn) {
      e.preventDefault();
      e.stopPropagation();
      clearHistory();
      hideAll();
      return;
    }

    // If clicking remove button for single item
    const removeBtn = e.target.closest('[data-blo-action="remove"]');
    if (removeBtn) {
      e.preventDefault();
      e.stopPropagation();
      const term = removeBtn.getAttribute('data-blo-remove');
      if (term) {
        removeQuery(term);
        const dropdown = removeBtn.closest('.blo-search-history');
        const container = dropdown ? dropdown.parentElement : null;
        const input = container ? container.querySelector('input[type="search"], input[name="q"]') : null;
        if (input) {
          showForInput(input);
        } else {
          hideAll();
        }
      }
      return;
    }

    // If clicking an item row
    const item = e.target.closest('.blo-search-history-item');
    if (item && !e.target.closest('[data-blo-action="remove"]')) {
      e.preventDefault();
      e.stopPropagation();
      const term = item.getAttribute('data-blo-query');
      if (term) {
        const dropdown = item.closest('.blo-search-history');
        const container = dropdown ? dropdown.parentElement : null;
        const form = container ? container.closest('form') : document.querySelector('form.search, #search_mini_form');
        const input = container ? container.querySelector('input[type="search"], input[name="q"]') : (form ? form.querySelector('input[name="q"]') : null);
        if (input) {
          input.value = term;
        }
        saveQuery(term);
        hideAll();
        if (form) {
          form.submit();
        } else {
          window.location.href = `/search?type=product&q=${encodeURIComponent(term)}`;
        }
      }
      return;
    }

    // Click outside: hide dropdowns
    if (!e.target.closest('.blo-search-history') && !e.target.matches('input[type="search"], input[name="q"]')) {
      hideAll();
    }
  });

  // Event Delegation for typing in search input
  document.addEventListener('input', function (e) {
    if (e.target.matches('input[type="search"], input[name="q"]')) {
      if (e.target.value.trim().length > 0) {
        hideAll();
      } else {
        showForInput(e.target);
      }
    }
  });

  // Capture submit on any form
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (form.matches('form.search, #search_mini_form, form[action*="/search"]')) {
      const input = form.querySelector('input[type="search"], input[name="q"]');
      if (input && input.value) {
        saveQuery(input.value);
      }
    }
  });

  // Escape key closes dropdown
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      hideAll();
    }
  });
})();
